/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useMemo, useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { FaEdit } from "react-icons/fa";
import { useUser } from "../../hooks/use-user";
import { useGetAllRoutes } from "../../services/routes-api";
import RoutesFilterBarV2 from "components/routesManagement/filter-bar";
import Loader from "components/PageLoader";
import {
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@repo/ui";
import EditRoute from "./edit-route";

export default function RoutesManagement() {
  const user = useUser();
  const pageSize = 25;

  const [routes, setRoutes] = useState([]);
  const [dataState, setDataState] = useState();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    searchCriteria: "",
    selectedCashCenterId: user?.CashCenterId ?? "",
    selectedCustomerId: "",
  });

  const operationDate = useMemo(() => new Date(), []);

  const {
    data: routesList,
    isSuccess: routesListAvailable,
    isFetching: gettingRoutesList,
  } = useGetAllRoutes({
    pageNumber: currentPage,
    pageRowCount: pageSize,
    searchCriteria: filters.searchCriteria,
    operationDate,
    cashCenterId: filters.selectedCashCenterId,
  });

  useEffect(() => {
    if (routesListAvailable && routesList?.data) {
      setRoutes(routesList.data.data);
      setTotalRecords(routesList.data.totalRecords);
    }
  }, [routesListAvailable, routesList]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };

  const editCell = ({ dataItem }) => (
    <td>
      <div
        className="flex justify-center w-full"
        title="Edit Consumables"
        onClick={() => {
          setOpenEditModal(true);
          setSelectedRoute(dataItem);
        }}
      >
        <FaEdit fontSize="18px" color="var(--primary-dark)" />
      </div>
    </td>
  );

  return (
    <div className="mx-4">
      {gettingRoutesList ? <Loader /> : null}

      <Card>
        <CardContent className="pt-4">
          <RoutesFilterBarV2
            getList={(searchCriteria, cashCenterId) => {
              setCurrentPage(1);
              setFilters({
                searchCriteria,
                selectedCashCenterId: cashCenterId,
              });
            }}
          />

          <Grid
            data={process(routes || [], { ...dataState, skip: 0 })}
            {...dataState}
            onDataStateChange={(e) => setDataState(e.dataState)}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
          >
            {/* <Column
              field={SELECTED_FIELD}
              filterable={false}
              width="80px"
              
            /> */}
            <Column field="cashCenter" title="Cash Center" width={200} />
            <Column field="office" title="Office" width={250} />
            <Column field="routeType" title="Route Type" width={160} />
            <Column field="routeNo" title="Route No" width={120} />
            <Column field="description" title="Description" width={200} />
            <Column field="routeArea" title="Area" width={160} />
            <Column field="region" title="Region" width={160} />
            <Column
              field="busTime"
              title="Bus Time"
              width={100}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="routeTime"
              title="Route Time"
              width={120}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="cashBoxSerial"
              title="Cash Box Serial#"
              width={160}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="hhtSerial"
              title="HHT Serial#"
              width={100}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="printerSerial"
              title="Printer Serial#"
              width={120}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="teamNationalityCount"
              title="Co-National Count"
              width={200}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="requiredTeamMembers"
              title="Team Members"
              width={140}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="vanRegistrationNo"
              title="Van Registration#"
              width={160}
              headerClassName="text-center"
              className="text-center"
            />
            <Column field="requestedBy" title="Requested By" width={120} />

            <Column width={100} field="status" title="Status" />
            <Column
              filterable={false}
              title="Edit"
              headerClassName="text-center"
              className="text-center"
              width={80}
              cell={editCell}
            />
          </Grid>
        </CardContent>
      </Card>
      <Dialog open={openEditModal} onOpenChange={setOpenEditModal}>
        <DialogContent className="max-w-[780px] w-full">
          <DialogHeader>
            <DialogTitle>Edit Route</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-4">
            <EditRoute
              route={selectedRoute}
              onRouteUpdated={() => setOpenEditModal(false)}
            />
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </div>
  );
}
